import { render, staticRenderFns } from "./ourTeam.vue?vue&type=template&id=0a8387bc"
import script from "./ourTeam.vue?vue&type=script&lang=js"
export * from "./ourTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports